<template lang="pug">
  .padding-container.create-document
    .flex-grid
      loading(:active.sync="loading")
      div.account
        Notice.success(v-if="success" :top="true") {{ $t('pages.create_document.success') }}
        h4.b-margin-sm {{ $t('pages.create_document.titles.document') }}
        hr
        .flex-grid
          .input-group  
            label {{ $t('fields.name') }}*
            input(v-model="object.name" :placeholder="$t('fields.name')")
          .input-group  
            label {{ $t('fields.type') }}*
            input(v-model="object.type" :placeholder="$t('fields.type')")
        .input-group
          FileUpload(@input="changedFile" @removedFile="removedFile")
        .flex-grid
          .creator(@click="createDocument(object)")
            Button(:text="$t('interface.create')")
    Notice(v-if="error") {{ error }}

</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  import moment from 'moment';

  import DocumentService from '@/services/document';
  import Api from '@/services/api'

  import Notice from '@/components/Notice';
  import FileUpload from '@/components/inputs/FileUpload';

  export default {
    data: function() {
      return {
        service: DocumentService,
        loading: false,
        success: '',
        error: '',
        file: null,
        file_name: null,
        created_id: 0,
        object: {
          publish_date: moment().format('llll'),
          published: true,
          is_template: true,
          type: 'Introduction',
          requires_premium: true,
          name: ''
        },
        object_form: {
          title: this.$t('pages.create_document.prompt_confirm_title'),
          text: this.$t('pages.create_document.prompt_confirm_text')
        }
      }
    },
    methods: {
      createDocument: async function(e) {
        let THISINSTANCE = this;
        let rawData = this.object;
        let formData = new FormData()
        let invalid = false;

        if(this.file == null) {
          THISINSTANCE.error = THISINSTANCE.$i18n.t('error_messages.field_required', { 
            text: THISINSTANCE.$i18n.t('fields.file')
          })
          invalid = true;

          this.file = null;
          this.file_name = null;
        }

        Object.keys(this.object).forEach(key => {
          const item = this.object[key];
          if(item != null && item != '' || item === false )
            formData.append( [key], JSON.stringify(item) )

          if(key === 'name') {
            if(item === '') {
              THISINSTANCE.error = THISINSTANCE.$i18n.t('error_messages.field_required', { 
                text: THISINSTANCE.$i18n.t('fields.name')
              })
              invalid = true;
            }
          }
        })

        if(invalid == false)
          this.error = null;

        if(this.error == null) {
          formData.append('file', this.file, this.file_name)
          const headers = { 'Content-Type': 'multipart/form-data' };
          Api().post(`uploadeddocument/upload`, formData, headers )
            .then(response => {
              this.error = null;
              this.created_id = response.data.id;
              this.success = THISINSTANCE.$i18n.t('pages.create_document.success');
              this.object.name = '';
              this.object.type = '';

              this.$swal.fire({
                title: 'Upload Success!',
                text: THISINSTANCE.$i18n.t('pages.create_document.success'),
                showCancelButton: true,
                type: 'success'
              })
                .then((result) => {
                  if (result.value) {
                    this.$router.push({
                      path: '/my-documents/uploaded-documents',
                    })
                  }
                })
     

            })
            .catch(err => {
              if(err.response.data.error !== undefined) {
                this.error = err.response.data.error
              } else {
                this.error = THISINSTANCE.$i18n.t('error_messages.' + err.response.data)
              }
              this.success = null;
            })
        }
      },
      dateChanged: function(e) {
        this.object.publish_date = e;
      },
      removedFile: function(e) {
        this.file = null;
        this.file_name = null;
      },
      changedFile: function(e) {
        this.file = e;
        this.file_name = e.name;
      }
    },
    created() {
      this.$on('loading', function (e) {
        this.loading = e;
      })
      this.$on('error', function (e) {
        this.error = e;
        this.success = '';
      })
      this.$on('success', function (e) {
        this.success = e;
        this.loading = false;
        this.error = '';

        let items = Object.keys(this.object);
        items.forEach(item => {
          this.object[item] = '';
        })
        this.object.published = true;
      })
    },
    components: { 
      FileUpload,
      Loading,
      Notice
    }
  }
</script>